const featuresData = [
    {
      icon: 'uil uil-water',
      title: 'Natural Flow',
      description:
        'Holuptate velit esse moleiae quam nihil consequatur voluptas  nulla every  pariatur?"',
    },
    {
      icon: 'uil uil-dropbox',
      title: 'Awesome Design',
      description:
        'Vestibulum mollis nibh interdum aculis proin auctor vulputate facilisis Etiam convallis posuere.',
    },
    {
      icon: 'uil uil-focus-target',
      title: 'Easy to customize',
      description:
        'Proin quis elit vitae nisi interdum ullamcorper sit amet eget diam sed non ornare libero.',
    },
    {
      icon: 'uil uil-fire',
      title: 'Hot Looks',
      description:
        'Consec tetureu suscipit metorbi dictum nec risus venenatis dictum duty vulputate.',
    },
    {
      icon: 'uil uil-game-structure',
      title: 'Unrivaled Quality',
      description:
        'Maenas sagittis placerat scele risque tempor Aliquam placerat neque scelerisque consectetur.',
    },
    {
      icon: 'uil uil-flower',
      title: 'Clean Design',
      description:
        'Aliquam dicadtunc senulla congue posuere bibendum erat sit amet tortor finibus.',
    },
  ];

  export default featuresData;